module.exports = __webpack_public_path__ + "static/media/img-dentist-thumb.23a7aa95.png";